import { IBlock } from "src/models/IBlock";

export class Block implements IBlock {
  id = 0;
  start_date = "";
  end_date = "";
}